// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TripApproval  {
    _originalTypeClassName = "Loom.BO.TripApproval";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TripApproval.translate = translateService;
}
this.Id = null;
this.DateOfApproval = null;
this.Comments = null;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
DateOfApproval:any;
Comments:any;
Status:any;
Trip:any;
Approver:any;
static setTrip = ($this, value) => {
var oldValue = $this.Trip;
$this.Trip = value;
if (value != null) {
if (oldValue != null) {
Domain.Trip.removeApprovals(oldValue, $this);
}
Domain.Trip.addApprovals(value, $this);
}
}
static setApprover = ($this, value) => {
var oldValue = $this.Approver;
$this.Approver = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}